import React,{useLayoutEffect,useRef} from 'react';
import {X} from 'lucide-react';

export default function ImprovementPointsFilterPopover({anchor,onClose,children}) {
  const menu=useRef(null),close=useRef(onClose);
  close.current=onClose;
  useLayoutEffect(()=>{
    const element=menu.current;
    const position=()=>{
      const rect=anchor.current?.getBoundingClientRect();if(!rect)return;
      const width=Math.min(280,window.innerWidth-24);
      element.style.width=`${width}px`;
      element.style.left=`${Math.max(12,Math.min(rect.right-width,window.innerWidth-width-12))}px`;
      const height=Math.min(element.scrollHeight,window.innerHeight-24);
      element.style.top=`${Math.max(12,Math.min(rect.bottom+8,window.innerHeight-height-12))}px`;
    };
    if(element.showPopover)element.showPopover();
    position();
    const outside=event=>{if(!element.contains(event.target) && !anchor.current?.contains(event.target))close.current();};
    document.addEventListener('pointerdown',outside);
    window.addEventListener('resize',position);window.addEventListener('scroll',position,true);
    return ()=>{document.removeEventListener('pointerdown',outside);window.removeEventListener('resize',position);window.removeEventListener('scroll',position,true);};
  },[anchor]);
  return <div ref={menu} popover="auto" role="dialog" aria-label="Filter improvement points" className="ImprovementPointsList__filter-popover" onToggle={event=>{if((event.newState || event.nativeEvent.newState)==='closed')close.current();}} onKeyDown={event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();onClose();anchor.current?.focus();}}}>
    <header><h4>Filter improvement points</h4><button type="button" className="ImprovementPointsList__icon app-cancel-control" aria-label="Close improvement point filters" onClick={()=>{onClose();anchor.current?.focus();}}><X size={16}/></button></header>
    {children}
  </div>;
}
